import { Modal } from '@cfs-fixings/shared'
import { DesignResource } from '@/api/serverApi'
import DuplicateDesignForm from '@/components/forms/designs/DuplicateDesignForm'

const textSpec = {
  title: 'Duplicate Design',
}

type PropTypes = {
  design: DesignResource
  isOpen: boolean
  onSuccess?: () => void
  onClose: () => void
}

const DuplicateDesignModal = ({ design, isOpen, onSuccess, onClose }: PropTypes) => {
  return (
    <Modal
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      title={textSpec.title}
      content={
        <DuplicateDesignForm
          design={design}
          onClose={onClose}
          onCompleted={() => onSuccess?.()}
        />
      }
    />
  )
}

export default DuplicateDesignModal
